module.exports = __webpack_public_path__ + "static/gallery26-4240d42d888c8954e6ab759732b2140c.png";